const Header = () => {
  return (
    <header className="text-4xl font-medium text-center py-4 text-indigo-500">
      <h1>tic-tac-toe</h1>
    </header>
  );
};

export default Header;
